import { createAsyncThunk } from '@reduxjs/toolkit';
import { PartnerAuditLog } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindPartnerAuditLog } from './interface';

export const findPartnerAuditLog = createAsyncThunk(
  'partnerAuditLog/findPartnerAuditLog',
  async (values: FindPartnerAuditLog, { rejectWithValue }) => {
    try {
      const query: Record<string, string | number> = {
        limit: values.limit ?? 25,
        skip: values.skip ?? 0,
      };
      if (values.partnerId) {
        query.partnerId = values.partnerId;
      }
      if (values.orderId) {
        query.orderId = values.orderId;
      }
      if (values.from) {
        query.from = values.from;
      }
      if (values.to) {
        query.to = values.to;
      }
      return await PartnerAuditLog.find({ query });
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
